import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";
import { ConversationTopicType } from "@/types/graphql/partner.generated";
import { TOPIC_LABEL_KEY } from "@/partner/entities/assistant";

const TOPIC_OPTIONS = Object.values(ConversationTopicType);

export const ConversationsFilter: FC = () => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("conversations.filterTitle")}
      fields={{ search: true }}
      selects={[
        {
          name: "topic",
          label: t("conversations.topicFilter"),
          options: TOPIC_OPTIONS.map((value) => ({
            value,
            label: t(TOPIC_LABEL_KEY[value]),
          })),
        },
        {
          name: "hasRequest",
          label: t("conversations.requestFilter"),
          options: [
            { value: "yes", label: t("conversations.requestYes") },
            { value: "no", label: t("conversations.requestNo") },
          ],
        },
      ]}
    />
  );
};
